module.exports = __webpack_public_path__ + "media/images/emblems/Prevonloup-8839b46e4d0faaa2f2df9275fc0071c9.svg";